<div class="container">
  <div [ngClass]="login.contraste ? 'card-panel mt-5 fundo-contraste' : 'card-panel mt-5 fundo-normal'">
    <div class="row">
      <div class="col-2">
        <img src="assets/img/planejamento.png" alt="" width="42" height="42">
      </div>
      <div class="col-10">
        <a [routerLink]="['/transparencia/portal']" class="btn btn-sm btn-outline-secondary float-right ml-5">
          <img src="assets/img/global/cross.png" alt="sair" title="Sair" height="30" width="30">
        </a>
      </div>
    </div>
    <div class="row">
      <div class="col-md">
        <div class="pt-3 mb-0 pb-0">
          <p style="margin-bottom: 1px;"
            [ngClass]="this.login.contraste ? 'titulo-contraste fonte-acessibilidade' : 'titulo-normal fonte-acessibilidade'">
            PLANO PLURIANUAL (PPA)
          <p style="margin-top: 1px;"
            [ngClass]="this.login.contraste ? 'texto-contraste fonte-acessibilidade' : 'texto-normal fonte-acessibilidade'">
            Destinado a organizar e viabilizar a ação pública, com vistas a
            cumprir os fundamentos e os objetivos da município.</p>
        </div>
      </div>
    </div>
    <hr [ngClass]="this.login.contraste ? 'linha-contraste mt-1 mb-4' : 'linha-normal mt-1 mb-2'" />
    <div class="row">
      <div class="form-group col-4" *ngIf="listaPpa !== null">
        <label for="ppa">Período</label>
        <select [compareWith]="compareFn" [(ngModel)]="ppa" id="ppa"
          class="form-control custom-select font-weight-bold">
          <option [ngValue]="item" *ngFor="let item of listaPpa">
            {{item.ppaperiodo.ano1}} - {{item.ppaperiodo.ano4}}
          </option>
        </select>
      </div>
    </div>
    <div class="row">
      <div class="col-6">
        <div
          [ngClass]="this.login.contraste ? 'card border-warning text-white fundo-contraste fonte-acessibilidade' : 'card border-info fundo-normal fonte-acessibilidade'"
          style="min-height: 17rem;">
          <div class="card-body">
            <h6
              [ngClass]="this.login.contraste ? 'card-title fonte-acessibilidade text-white' : 'card-title fonte-acessibilidade'"
              style="color: #388e3c;">Anexo I - Fonte Financiamento</h6>
            <p class="card-text fonte-acessibilidade" style="text-align: justify">
              É um princípio do PPA a sua aderência às políticas públicas tal como reconhecidas pelo governo e
              pela sociedade. Esta aderência se traduz, no que se refere à alocação de recursos, na consideração
              de todas as fontes de fi nanciamento das políticas: orçamentárias e extraorçamentárias.
            </p>
            <button type="button"
              [ngClass]="this.login.contraste ? 'btn btn-sm btn-warning fonte-acessibilidade' : 'btn btn-sm btn-primary fonte-acessibilidade'"
              (click)="anexoI()">Visualizar</button>
          </div>
        </div>
      </div>
      <div class="col-6">
        <div
          [ngClass]="this.login.contraste ? 'card border-warning text-white fundo-contraste fonte-acessibilidade' : 'card border-info fundo-normal fonte-acessibilidade'"
          style="min-height: 17rem;">
          <div class="card-body">
            <h6
              [ngClass]="this.login.contraste ? 'card-title fonte-acessibilidade text-white' : 'card-title fonte-acessibilidade'"
              style="color: #388e3c;">Anexo II - Programa de Governo</h6>
            <p class="card-text fonte-acessibilidade" style="text-align: justify">
              Programa é um instrumento de organização da Ação Governamental que articula um conjunto de iniciativas
              públicas e privadas - projetos, atividades, financiamentos, incentivos fiscais, normas, etc. - e que visam
              à solução de um problema ou ao atendimento de demanda da Sociedade, sendo mensurado por indicadores.
            </p>
            <button type="button"
              [ngClass]="this.login.contraste ? 'btn btn-sm btn-warning fonte-acessibilidade' : 'btn btn-sm btn-primary fonte-acessibilidade'"
              (click)="anexoII()">Visualizar</button>
          </div>
        </div>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-6">
        <div
          [ngClass]="this.login.contraste ? 'card border-warning text-white fundo-contraste fonte-acessibilidade' : 'card border-info fundo-normal fonte-acessibilidade'"
          style="min-height: 17rem;">
          <div class="card-body">
            <h6
              [ngClass]="this.login.contraste ? 'card-title fonte-acessibilidade text-white' : 'card-title fonte-acessibilidade'">
              Anexo III - Ações de Governo
            </h6>
            <p class="card-text fonte-acessibilidade" style="text-align: justify">
              Para alcançar os objetivos dos programas, o orçamento define as chamadas ações orçamentárias. Elas
              representam um detalhamento dos programas, por vezes segmentando os trabalhos com bases em linhas
              específicas para atender as necessidades da sociedade ou até de outros entes da federação.
            </p>
            <button type="button"
              [ngClass]="this.login.contraste ? 'btn btn-sm btn-warning fonte-acessibilidade' : 'btn btn-sm btn-primary fonte-acessibilidade'"
              (click)="anexoIII()">Visualizar</button>
          </div>
        </div>
      </div>
    </div>
    <div class="row mt-5">
      <div class="col-md">
        <div class="pt-3 mb-0 pb-0">
          <p style="margin-bottom: 1px;"
            [ngClass]="this.login.contraste ? 'titulo-contraste fonte-acessibilidade' : 'titulo-normal fonte-acessibilidade'">
            LEI ORÇAMENTÁRIA ANUAL (LOA)
          <p style="margin-top: 1px;"
            [ngClass]="this.login.contraste ? 'texto-contraste fonte-acessibilidade' : 'texto-normal fonte-acessibilidade'">
            Lei elaborada pelo Poder Executivo que estabelece as despesas e
            as receitas que serão realizadas no próximo ano.</p>
        </div>
      </div>
    </div>
    <hr [ngClass]="this.login.contraste ? 'linha-contraste mt-1 mb-4' : 'linha-normal mt-1 mb-2'" />
    <div class="row" *ngIf="login">
      <div class="form-group col-md-3">
        <label for="ano">Exercício</label>
        <select [compareWith]="compareFn" [(ngModel)]="exercicio" id="ano"
          class="form-control custom-select font-weight-bold">
          <option *ngFor="let item of listaExercicios" [ngValue]="item">
            {{item.ano}}
          </option>
        </select>
      </div>
    </div>
    <div class="row mt-3" *ngIf="parametro.mostrar_relatorio_loa">
      <div class="col-6">
        <div *ngIf="exercicio"
          [ngClass]="this.login.contraste ? 'card border-warning text-white fundo-contraste fonte-acessibilidade' : 'card border-info fundo-normal fonte-acessibilidade'"
          style="min-height: 14rem;">
          <div class="card-body">
            <h6
              [ngClass]="this.login.contraste ? 'card-title fonte-acessibilidade text-white' : 'card-title fonte-acessibilidade'"
              style="font-weight: 200;">Receitas Prevista</h6>
            <p class="card-text fonte-acessibilidade" style="text-align: justify">
              É a primeira fase da arrecadação de recursos. As Receitas do governo passam por uma previsão inicial e
              essa previsão é atualizada ao longo do ano para se ajudar às mudanças que ocorrem durante o período.
            </p>
            <a [ngClass]="this.login.contraste ? 'btn btn-sm btn-warning fonte-acessibilidade' : 'btn btn-sm btn-primary fonte-acessibilidade'"
              [routerLink]="['/transparencia/receita-prevista', exercicio.ano]">Visualizar</a>
          </div>
        </div>
      </div>
      <div class="col-6">
        <div *ngIf="exercicio"
          [ngClass]="this.login.contraste ? 'card border-warning text-white fundo-contraste fonte-acessibilidade' : 'card border-info fundo-normal fonte-acessibilidade'"
          style="min-height: 14rem;">
          <div class="card-body">
            <h6
              [ngClass]="this.login.contraste ? 'card-title fonte-acessibilidade text-white' : 'card-title fonte-acessibilidade'"
              style="font-weight: 200;">Cronograma Desembolso</h6>
            <p class="card-text fonte-acessibilidade" style="text-align: justify">
              O cronograma de desembolso mensal que irá nortear o fluxo de pagamento e qual a proporção pagas das
              despesas do município, considerando o desenho mensal da arrecadação das receitas.
            </p>
            <a [ngClass]="this.login.contraste ? 'btn btn-sm btn-warning fonte-acessibilidade' : 'btn btn-sm btn-primary fonte-acessibilidade'"
              [routerLink]="['/transparencia/despesa-prevista', exercicio.ano]">Visualizar</a>
          </div>
        </div>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-4">

      </div>
      <div class="col-4">

      </div>
      <div class="col-4">

      </div>
    </div>
  </div>
</div>
